import React, { useContext, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { LayoutContext } from "../App";
import Clientdata from "./Clientdata";
import { Helmet } from "react-helmet";
import WhyChoosedata from "./WhyChoosedata";
import IframeForm from "./IframeForm";
import LangbyBlog from "./LangbyBlog";
import useWebsiteSetting , {useBlogdetails} from "../FetchAPI";

export default function BlogDetails() {
const { setShowLayout } = useContext(LayoutContext);

  let { slug } = useParams();
  const [webSetting] = useWebsiteSetting();
  const [Blogdetails] = useBlogdetails(slug);


  useEffect(() => {
  if (Number(Blogdetails?.template_id) === 2) {
    setShowLayout(false);
  } else {
    setShowLayout(true);
  }

  return () => {
    setShowLayout(true);
  };
}, [Blogdetails, setShowLayout]);

  const showBanner = () => {
    let AddData = "";
    if (Blogdetails.uploadType === "0") {
      AddData = (
        <div className="blog_iframe">
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${Blogdetails.bannerVideo}`}
            title="Name Change Service in India | Name Change Agent in India"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen=""
          ></iframe>
        </div>
      );
    } else if (Blogdetails.uploadType === "1") {
      AddData = (
        <img
          src={Blogdetails.bannerImage}
          alt={Blogdetails.image_alt}
          title={Blogdetails.image_title}
          className="bannerimg"
        />
      );
    } else {
      AddData = (
        <div className="banner_desc">
          <div className="BannerDsceBox">
            <h2
              dangerouslySetInnerHTML={{
                __html: Blogdetails.bannerDesc,
              }}
            ></h2>
          </div>
        </div>
      );
    }
    return AddData;
  };


  if (Number(Blogdetails?.template_id) === 2) {
  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: Blogdetails.description,
        }}
      />
    </>
  );
} else {

  return (
    <>
      <Helmet>
        <title>{Blogdetails?.meta_title}</title>
        <meta name="description" content={Blogdetails?.meta_description} />
        <meta name="keywords" content={Blogdetails?.meta_keyword} />
        <link rel="canonical" href={window.location.href} />

        {Blogdetails?.custom_script && (
          <script type="application/ld+json">
            {Blogdetails?.custom_script}
          </script>
        )}

        {Blogdetails?.custom_script2 && (
          <script type="application/ld+json">
            {Blogdetails?.custom_script2}
          </script>
        )}
      </Helmet>

      <section className="PageBanner_section">{showBanner()}</section>

      <section className="section_padding blogDetails_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 ml-2 BlogTopForm">
              <IframeForm/>
            </div>
            <div className="col-lg-8">
              <div className="blog_content">
                <article id="post-87" className="single single-post">
                  <div className="post-header">
                    <p className="post-categories">{Blogdetails.category}</p>
                    <h1 className="post-title">{Blogdetails.title}</h1>
                    <div className="post-meta">
                      <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 mt-3">
                          {/* <span className="post-meta-date">
                            {Blogdetails.date}
                          </span> */}
                          <span className="post-meta-date">
                            <i className="fa fa-user bogdetailsicon" aria-hidden="true"></i>
                            {Blogdetails.author}
                          </span>
                          <span className="post-meta-date blogdetailsDate">
                            <i className="fa fa-calendar bogdetailsicon" aria-hidden="true"></i>
                            {Blogdetails.date}
                          </span>
                        </div>

                        <div className="col-lg-6 col-md-12 Post_comm_shere mt-3">
                          <span className="post-comments">
                            <span className="fa fw fa-comment"></span>12
                            <span className="resp"> Comments</span>
                          </span>
                          <div className="share-post">
                            <Link
                              className="fb_share"
                              onClick={() => {
                                window.open(
                                  "https://www.facebook.com/sharer/",
                                  "Share This Post",
                                  "width=640,height=450"
                                );
                              }}
                              title="facebook"
                            >
                              <i className="fa fa-facebook" aria-hidden="true"></i>
                            </Link>
                            <Link
                              className="fb_twitter"
                              onClick={() => {
                                window.open(
                                  "https://twitter.com/",
                                  "Share This Post",
                                  "width=640,height=450"
                                );
                              }}
                              title="Twitter"
                            >
                              <i
                                className="fa fa-twitter"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <Link
                              to={
                                Blogdetails.lang === "en"
                                  ? `https://api.whatsapp.com/send?text=${slug} - ${webSetting.baseURl}${slug}`
                                  : `https://api.whatsapp.com/send?text=${slug} - ${webSetting.baseURl}${Blogdetails.lang}/${slug}`
                              }
                              className="fb_whatsapp"
                              title="Whatsapp"
                              rel="nofollow noopener"
                              target="_blank"
                            >
                              <i
                                className="fa fa-whatsapp"
                                aria-hidden="true"
                              ></i>
                            </Link>

                            <Link
                              className="fb_linkedin"
                              onClick={() => {
                                window.open(
                                  "http://www.linkedin.com/shareArticle/",
                                  "Share This Post",
                                  "width=640,height=450"
                                );
                              }}
                              title="linkedin"
                            >
                              <i
                                className="fa fa-linkedin"
                                aria-hidden="true"
                              ></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="postflex">
                    <div className="post-inner">
                      <div
                        className="post-content entry-content"
                        dangerouslySetInnerHTML={{
                          __html: Blogdetails.description,
                        }}
                      ></div>
                    </div>
                  </div>
                </article>
              </div>
            </div>


            
            <div className="col-lg-4 ml-2 BlogSiteForm">
              <IframeForm/>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section Start */}
      <WhyChoosedata />
      {/* Why Choose Us Section End */}


      {Blogdetails.description2 && (
        <section>
               <div className="container">
          <div className="row">
            <div className="col-lg-12 "> 
      <div
      className="post-content entry-content"
      dangerouslySetInnerHTML={{
      __html: Blogdetails.description2,
      }}
      ></div>
      </div>
      </div>
      </div>
</section>
      )}


      {/* Client Section Start */}
      <Clientdata />
      {/* Client Section End */}
      

      {/* Blog section Start */}
          <LangbyBlog
            language={Blogdetails.lang}
          />
  
      {/* Blog section End */}
    </>
  );
}

}
